import React, { useMemo, useState } from "react";
import {
  Plus,
  Search,
  ArrowsExpandVertical,
  ChevronDoubleLeft,
  ViewList,
  Download,
} from "react-bootstrap-icons";
import Header from "../../layouts/Header";

const initialForm = {
  outlet_id: "",
  outlet_name: "",
  outlet_code: "",
  city: "",
  outlet_area: "",
  floor: "",
  exact_position: "",

  asset_name: "",
  asset_category: "Electrical",
  asset_type: "",
  brand: "",
  model_no: "",
  serial_no: "",
  asset_code: "",
  qr_code: "",
  barcode: "",
  rfid_tag: "",

  quantity: 1,
  unit: "PCS",

  acquisition_type: "PURCHASED",
  ownership_type: "OWNED",
  lifecycle_stage: "IN_USE",
  commissioning_date: "",
  decommissioning_date: "",
  disposal_date: "",
  disposal_reason: "",

  purchase_date: "",
  purchase_price: "",
  current_book_value: "",
  depreciation_method: "NONE",
  depreciation_rate: "",
  salvage_value: "",
  vendor_name: "",
  invoice_no: "",
  invoice_file: null,

  warranty_available: false,
  warranty_start_date: "",
  warranty_end_date: "",

  amc_available: false,
  amc_vendor_name: "",
  amc_contract_no: "",
  amc_start_date: "",
  amc_end_date: "",
  amc_service_frequency: "NONE",
  amc_contract_file: null,

  compliance_required: false,
  last_inspection_date: "",
  next_inspection_date: "",
  certificate_no: "",
  certificate_file: null,

  installation_date: "",
  installed_location: "",

  condition: "GOOD",
  status: "ACTIVE",

  power_rating: "",
  voltage: "",
  amperage: "",

  maintenance_required: false,
  maintenance_frequency: "NONE",
  last_maintenance_date: "",
  next_maintenance_date: "",

  service_type: "PREVENTIVE",
  service_vendor_name: "",
  technician_name: "",
  service_cost: "",
  issue_reported: "",
  work_done: "",

  transfer_from_outlet: "",
  transfer_to_outlet: "",
  transfer_date: "",
  transfer_reason: "",

  assigned_to: "",
  remarks: "",

  images: [],
  documents: [],

  is_deleted: false,
  created_by_name: "Admin",
  updated_by_name: "",
  deleted_by_name: "",
  deleted_at: "",
};

const dummyAssets = [
  {
    _id: "1",
    outlet_name: "Cafe Pune",
    outlet_code: "OUT-PN-001",
    city: "Pune",
    outlet_area: "Dining Area",
    floor: "Ground Floor",
    exact_position: "Near entrance",

    asset_name: "Split AC",
    asset_category: "Electrical",
    asset_type: "AC",
    brand: "Daikin",
    model_no: "FTKP50",
    serial_no: "AC998812",
    asset_code: "AST-0001",
    qr_code: "QR-AST-0001",
    barcode: "BAR-AST-0001",

    quantity: 2,
    unit: "PCS",

    acquisition_type: "PURCHASED",
    ownership_type: "OWNED",
    lifecycle_stage: "IN_USE",
    purchase_price: 82000,
    current_book_value: 65000,
    depreciation_method: "STRAIGHT_LINE",
    depreciation_rate: 10,

    condition: "GOOD",
    status: "ACTIVE",
    installed_location: "Dining Area",
    next_maintenance_date: "2026-07-10",

    amc_available: true,
    amc_vendor_name: "Daikin Service Partner",
    amc_end_date: "2027-03-31",

    compliance_required: true,
    next_inspection_date: "2026-08-01",

    maintenance_history: [
      {
        service_date: "2026-05-10",
        service_type: "PREVENTIVE",
        vendor_name: "Daikin Service Partner",
        technician_name: "Rahul",
        cost: 2500,
        issue_reported: "Routine cleaning",
        work_done: "Filter cleaning and gas check",
        next_service_date: "2026-07-10",
      },
    ],
    transfer_history: [],
  },
  {
    _id: "2",
    outlet_name: "Cafe Mumbai",
    outlet_code: "OUT-MU-002",
    city: "Mumbai",
    outlet_area: "Kitchen",
    floor: "Ground Floor",
    exact_position: "Cold storage corner",

    asset_name: "Deep Freezer",
    asset_category: "Kitchen Equipment",
    asset_type: "Freezer",
    brand: "Blue Star",
    model_no: "CHF500",
    serial_no: "FRZ778822",
    asset_code: "AST-0002",
    qr_code: "QR-AST-0002",
    barcode: "BAR-AST-0002",

    quantity: 1,
    unit: "PCS",

    acquisition_type: "PURCHASED",
    ownership_type: "OWNED",
    lifecycle_stage: "REPAIR",
    purchase_price: 56000,
    current_book_value: 41000,
    depreciation_method: "WDV",
    depreciation_rate: 15,

    condition: "NEEDS_REPAIR",
    status: "UNDER_REPAIR",
    installed_location: "Kitchen",
    next_maintenance_date: "2026-06-28",

    amc_available: false,
    compliance_required: false,

    maintenance_history: [],
    transfer_history: [],
  },
];

const categories = [
  "Electrical",
  "Kitchen Equipment",
  "Furniture",
  "IT Equipment",
  "Safety Equipment",
  "Cleaning Equipment",
  "Other",
];

const assetTypes = [
  "AC",
  "Refrigerator",
  "Freezer",
  "Oven",
  "Mixer",
  "Coffee Machine",
  "Water Purifier",
  "Fan",
  "Light",
  "Inverter",
  "UPS",
  "Printer",
  "POS Machine",
  "CCTV",
  "Other",
];

const conditions = ["NEW", "GOOD", "AVERAGE", "NEEDS_REPAIR", "DAMAGED"];

const statuses = [
  "ACTIVE",
  "INACTIVE",
  "UNDER_REPAIR",
  "TRANSFERRED",
  "SCRAPPED",
  "SOLD",
];

const maintenanceFrequency = [
  "NONE",
  "WEEKLY",
  "MONTHLY",
  "QUARTERLY",
  "HALF_YEARLY",
  "YEARLY",
];

const acquisitionTypes = ["PURCHASED", "RENTED", "LEASED", "TRANSFERRED"];
const ownershipTypes = ["OWNED", "RENTED", "VENDOR_OWNED"];
const lifecycleStages = ["IN_USE", "IN_STORAGE", "REPAIR", "SCRAPPED", "SOLD"];
const depreciationMethods = ["NONE", "STRAIGHT_LINE", "WDV"];
const serviceTypes = ["PREVENTIVE", "BREAKDOWN", "INSTALLATION", "INSPECTION"];

const AssetAllocation = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const [assets, setAssets] = useState(dummyAssets);
  const [form, setForm] = useState(initialForm);
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [viewAsset, setViewAsset] = useState(null);

  const filteredAssets = useMemo(() => {
    const q = search.toLowerCase();

    return assets
      .filter((item) => !item.is_deleted)
      .filter((item) => {
        return (
          item.asset_name?.toLowerCase().includes(q) ||
          item.asset_code?.toLowerCase().includes(q) ||
          item.outlet_name?.toLowerCase().includes(q) ||
          item.brand?.toLowerCase().includes(q) ||
          item.serial_no?.toLowerCase().includes(q) ||
          item.qr_code?.toLowerCase().includes(q) ||
          item.barcode?.toLowerCase().includes(q)
        );
      });
  }, [assets, search]);

  const stats = useMemo(() => {
    const activeAssets = assets.filter((x) => !x.is_deleted);

    return {
      total: activeAssets.length,
      active: activeAssets.filter((x) => x.status === "ACTIVE").length,
      repair: activeAssets.filter((x) => x.status === "UNDER_REPAIR").length,
      damaged: activeAssets.filter((x) => x.condition === "DAMAGED").length,
    };
  }, [assets]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      setForm((prev) => ({
        ...prev,
        [name]: files?.[0] || null,
      }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () => {
    setForm(initialForm);
    setEditingId(null);
    setShowForm(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const maintenanceEntry =
      form.service_vendor_name ||
      form.technician_name ||
      form.issue_reported ||
      form.work_done
        ? {
            service_date: form.last_maintenance_date || new Date().toISOString().slice(0, 10),
            service_type: form.service_type,
            vendor_name: form.service_vendor_name,
            technician_name: form.technician_name,
            cost: Number(form.service_cost || 0),
            issue_reported: form.issue_reported,
            work_done: form.work_done,
            next_service_date: form.next_maintenance_date,
          }
        : null;

    const transferEntry =
      form.transfer_from_outlet || form.transfer_to_outlet || form.transfer_date
        ? {
            from_outlet_name: form.transfer_from_outlet,
            to_outlet_name: form.transfer_to_outlet,
            transfer_date: form.transfer_date,
            reason: form.transfer_reason,
            remarks: form.remarks,
          }
        : null;

    const existingAsset = assets.find((item) => item._id === editingId);

    const payload = {
      ...form,
      _id: editingId || Date.now().toString(),
      purchase_price: Number(form.purchase_price || 0),
      current_book_value: Number(form.current_book_value || 0),
      depreciation_rate: Number(form.depreciation_rate || 0),
      salvage_value: Number(form.salvage_value || 0),
      quantity: Number(form.quantity || 1),
      service_cost: Number(form.service_cost || 0),
      updated_by_name: "Admin",
      updatedAt: new Date().toISOString(),
      createdAt: existingAsset?.createdAt || new Date().toISOString(),
      maintenance_history: [
        ...(existingAsset?.maintenance_history || []),
        ...(maintenanceEntry ? [maintenanceEntry] : []),
      ],
      transfer_history: [
        ...(existingAsset?.transfer_history || []),
        ...(transferEntry ? [transferEntry] : []),
      ],
    };

    if (editingId) {
      setAssets((prev) =>
        prev.map((item) => (item._id === editingId ? payload : item))
      );
    } else {
      setAssets((prev) => [payload, ...prev]);
    }

    resetForm();
  };

  const handleEdit = (asset) => {
    setForm({
      ...initialForm,
      ...asset,
    });
    setEditingId(asset._id);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Soft delete this asset?");
    if (!confirmDelete) return;

    setAssets((prev) =>
      prev.map((item) =>
        item._id === id
          ? {
              ...item,
              is_deleted: true,
              deleted_by_name: "Admin",
              deleted_at: new Date().toISOString(),
            }
          : item
      )
    );
  };

  const badgeClass = (status) => {
    if (status === "ACTIVE") return "bg-success";
    if (status === "UNDER_REPAIR") return "bg-warning text-dark";
    if (status === "SCRAPPED" || status === "DAMAGED") return "bg-danger";
    if (status === "TRANSFERRED") return "bg-info text-dark";
    return "bg-secondary";
  };

  const renderSelect = (name, value, options) => (
    <select name={name} className="form-select" value={value} onChange={handleChange}>
      {options.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>
  );

  const renderText = (label, name, placeholder = "", type = "text", required = false) => (
    <div className="col-md-3">
      <label className="form-label">{label}</label>
      <input
        type={type}
        name={name}
        className="form-control"
        value={form[name] || ""}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
      />
    </div>
  );

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />

      <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
        <div className={`container-fluid py-4 min-vh-100 ${skin === "dark" ? "bg-dark" : "bg-light"}`}>
          <style>{`
            .asset-card {
              border: 0;
              border-radius: 18px;
              box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
            }

            .stat-card {
              border: 0;
              border-radius: 18px;
              background: #fff;
              box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
            }

            .form-label {
              font-size: 13px;
              font-weight: 600;
              color: #334155;
            }

            .form-control,
            .form-select {
              border-radius: 12px;
              min-height: 42px;
            }

            .section-title {
              font-size: 15px;
              font-weight: 700;
              color: #0f172a;
              border-left: 4px solid #0d6efd;
              padding-left: 10px;
              margin-bottom: 18px;
            }

            .table thead th {
              font-size: 13px;
              text-transform: uppercase;
              color: #64748b;
              background: #f8fafc;
            }

            .table tbody td {
              vertical-align: middle;
              font-size: 14px;
            }

            .action-btn {
              width: 34px;
              height: 34px;
              border-radius: 10px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
            }

            .sub-section {
              background: #f8fafc;
              border: 1px solid #e2e8f0;
              border-radius: 16px;
              padding: 18px;
              margin-bottom: 22px;
            }
          `}</style>

          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1">Outlet Asset Management</h3>
              <p className="text-muted mb-0">
                Manage outlet-wise assets, warranty, AMC, maintenance, compliance, transfer and lifecycle.
              </p>
            </div>

            <button
              className="btn btn-primary rounded-pill px-4"
              onClick={() => {
                setShowForm(true);
                setEditingId(null);
                setForm(initialForm);
              }}
            >
              <Plus className="me-2" />
              Add Asset
            </button>
          </div>

          <div className="row g-3 mb-4">
            <div className="col-md-3">
              <div className="stat-card p-3">
                <p className="text-muted mb-1">Total Assets</p>
                <h4 className="fw-bold mb-0">{stats.total}</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stat-card p-3">
                <p className="text-muted mb-1">Active Assets</p>
                <h4 className="fw-bold text-success mb-0">{stats.active}</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stat-card p-3">
                <p className="text-muted mb-1">Under Repair</p>
                <h4 className="fw-bold text-warning mb-0">{stats.repair}</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stat-card p-3">
                <p className="text-muted mb-1">Damaged</p>
                <h4 className="fw-bold text-danger mb-0">{stats.damaged}</h4>
              </div>
            </div>
          </div>

          {showForm && (
            <div className="card asset-card mb-4">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold mb-0">
                    {editingId ? "Update Asset" : "Add New Asset"}
                  </h5>

                  <button className="btn btn-light rounded-pill" onClick={resetForm}>
                    Cancel
                  </button>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="section-title">Outlet & Physical Location</div>

                  <div className="row g-3 mb-4">
                    {renderText("Outlet Name", "outlet_name", "Cafe Pune", "text", true)}
                    {renderText("Outlet Code", "outlet_code", "OUT-PN-001")}
                    {renderText("City", "city", "Pune")}
                    {renderText("Outlet Area", "outlet_area", "Kitchen / Dining / Store")}
                    {renderText("Floor", "floor", "Ground Floor")}
                    {renderText("Exact Position", "exact_position", "Near entrance / Back wall")}
                    {renderText("Installed Location", "installed_location", "Kitchen / Dining / Store")}
                  </div>

                  <div className="section-title">Asset Identity</div>

                  <div className="row g-3 mb-4">
                    {renderText("Asset Name", "asset_name", "Split AC", "text", true)}

                    <div className="col-md-3">
                      <label className="form-label">Category</label>
                      {renderSelect("asset_category", form.asset_category, categories)}
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Asset Type</label>
                      <select
                        name="asset_type"
                        className="form-select"
                        value={form.asset_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Type</option>
                        {assetTypes.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    {renderText("Asset Code", "asset_code", "AST-0001", "text", true)}
                    {renderText("QR Code", "qr_code", "QR-AST-0001")}
                    {renderText("Barcode", "barcode", "BAR-AST-0001")}
                    {renderText("RFID Tag", "rfid_tag", "RFID-001")}
                    {renderText("Brand", "brand", "Daikin / Blue Star")}
                    {renderText("Model No", "model_no")}
                    {renderText("Serial No", "serial_no")}
                    {renderText("Quantity", "quantity", "1", "number")}
                  </div>

                  <div className="section-title">Lifecycle & Ownership</div>

                  <div className="row g-3 mb-4">
                    <div className="col-md-3">
                      <label className="form-label">Acquisition Type</label>
                      {renderSelect("acquisition_type", form.acquisition_type, acquisitionTypes)}
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Ownership Type</label>
                      {renderSelect("ownership_type", form.ownership_type, ownershipTypes)}
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Lifecycle Stage</label>
                      {renderSelect("lifecycle_stage", form.lifecycle_stage, lifecycleStages)}
                    </div>

                    {renderText("Commissioning Date", "commissioning_date", "", "date")}
                    {renderText("Decommissioning Date", "decommissioning_date", "", "date")}
                    {renderText("Disposal Date", "disposal_date", "", "date")}
                    {renderText("Disposal Reason", "disposal_reason", "Sold / damaged / obsolete")}
                  </div>

                  <div className="section-title">Electrical Specifications</div>

                  <div className="row g-3 mb-4">
                    {renderText("Power Rating", "power_rating", "1.5 Ton / 1200W")}
                    {renderText("Voltage", "voltage", "220V")}
                    {renderText("Amperage", "amperage", "10A")}
                  </div>

                  <div className="section-title">Purchase, Finance & Depreciation</div>

                  <div className="row g-3 mb-4">
                    {renderText("Purchase Date", "purchase_date", "", "date")}
                    {renderText("Purchase Price", "purchase_price", "0", "number")}
                    {renderText("Current Book Value", "current_book_value", "0", "number")}

                    <div className="col-md-3">
                      <label className="form-label">Depreciation Method</label>
                      {renderSelect("depreciation_method", form.depreciation_method, depreciationMethods)}
                    </div>

                    {renderText("Depreciation Rate %", "depreciation_rate", "10", "number")}
                    {renderText("Salvage Value", "salvage_value", "0", "number")}
                    {renderText("Vendor Name", "vendor_name")}
                    {renderText("Invoice No", "invoice_no")}

                    <div className="col-md-3">
                      <label className="form-label">Invoice File</label>
                      <input type="file" name="invoice_file" className="form-control" onChange={handleChange} />
                    </div>
                  </div>

                  <div className="section-title">Warranty & AMC</div>

                  <div className="row g-3 mb-4">
                    <div className="col-md-3 d-flex align-items-center">
                      <div className="form-check mt-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="warranty_available"
                          checked={form.warranty_available}
                          onChange={handleChange}
                        />
                        <label className="form-check-label fw-semibold">Warranty Available</label>
                      </div>
                    </div>

                    {form.warranty_available && (
                      <>
                        {renderText("Warranty Start Date", "warranty_start_date", "", "date")}
                        {renderText("Warranty End Date", "warranty_end_date", "", "date")}
                      </>
                    )}

                    <div className="col-md-3 d-flex align-items-center">
                      <div className="form-check mt-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="amc_available"
                          checked={form.amc_available}
                          onChange={handleChange}
                        />
                        <label className="form-check-label fw-semibold">AMC Available</label>
                      </div>
                    </div>

                    {form.amc_available && (
                      <>
                        {renderText("AMC Vendor", "amc_vendor_name")}
                        {renderText("AMC Contract No", "amc_contract_no")}
                        {renderText("AMC Start Date", "amc_start_date", "", "date")}
                        {renderText("AMC End Date", "amc_end_date", "", "date")}

                        <div className="col-md-3">
                          <label className="form-label">AMC Service Frequency</label>
                          {renderSelect("amc_service_frequency", form.amc_service_frequency, maintenanceFrequency)}
                        </div>

                        <div className="col-md-3">
                          <label className="form-label">AMC Contract File</label>
                          <input type="file" name="amc_contract_file" className="form-control" onChange={handleChange} />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="section-title">Compliance & Safety Inspection</div>

                  <div className="row g-3 mb-4">
                    <div className="col-md-3 d-flex align-items-center">
                      <div className="form-check mt-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="compliance_required"
                          checked={form.compliance_required}
                          onChange={handleChange}
                        />
                        <label className="form-check-label fw-semibold">Compliance Required</label>
                      </div>
                    </div>

                    {form.compliance_required && (
                      <>
                        {renderText("Last Inspection Date", "last_inspection_date", "", "date")}
                        {renderText("Next Inspection Date", "next_inspection_date", "", "date")}
                        {renderText("Certificate No", "certificate_no")}

                        <div className="col-md-3">
                          <label className="form-label">Certificate File</label>
                          <input type="file" name="certificate_file" className="form-control" onChange={handleChange} />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="section-title">Status & Maintenance</div>

                  <div className="row g-3 mb-4">
                    <div className="col-md-3">
                      <label className="form-label">Condition</label>
                      {renderSelect("condition", form.condition, conditions)}
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Status</label>
                      {renderSelect("status", form.status, statuses)}
                    </div>

                    {renderText("Installation Date", "installation_date", "", "date")}
                    {renderText("Assigned To", "assigned_to", "Manager / Staff Name")}

                    <div className="col-md-3 d-flex align-items-center">
                      <div className="form-check mt-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="maintenance_required"
                          checked={form.maintenance_required}
                          onChange={handleChange}
                        />
                        <label className="form-check-label fw-semibold">Maintenance Required</label>
                      </div>
                    </div>

                    {form.maintenance_required && (
                      <>
                        <div className="col-md-3">
                          <label className="form-label">Maintenance Frequency</label>
                          {renderSelect("maintenance_frequency", form.maintenance_frequency, maintenanceFrequency)}
                        </div>

                        {renderText("Last Maintenance Date", "last_maintenance_date", "", "date")}
                        {renderText("Next Maintenance Date", "next_maintenance_date", "", "date")}
                      </>
                    )}
                  </div>

                  <div className="sub-section">
                    <div className="section-title">Add Maintenance / Repair History Entry</div>

                    <div className="row g-3">
                      <div className="col-md-3">
                        <label className="form-label">Service Type</label>
                        {renderSelect("service_type", form.service_type, serviceTypes)}
                      </div>

                      {renderText("Service Vendor", "service_vendor_name")}
                      {renderText("Technician Name", "technician_name")}
                      {renderText("Service Cost", "service_cost", "0", "number")}
                      {renderText("Issue Reported", "issue_reported")}
                      {renderText("Work Done", "work_done")}
                    </div>
                  </div>

                  <div className="sub-section">
                    <div className="section-title">Transfer Entry</div>

                    <div className="row g-3">
                      {renderText("From Outlet", "transfer_from_outlet")}
                      {renderText("To Outlet", "transfer_to_outlet")}
                      {renderText("Transfer Date", "transfer_date", "", "date")}
                      {renderText("Transfer Reason", "transfer_reason")}
                    </div>
                  </div>

                  <div className="section-title">Remarks</div>

                  <div className="row g-3 mb-4">
                    <div className="col-md-12">
                      <textarea
                        name="remarks"
                        className="form-control"
                        rows="3"
                        value={form.remarks}
                        onChange={handleChange}
                        placeholder="Any additional notes about asset condition, repair history, installation details etc."
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-light rounded-pill px-4" onClick={resetForm}>
                      Cancel
                    </button>

                    <button type="submit" className="btn btn-primary rounded-pill px-4">
                      {editingId ? "Update Asset" : "Save Asset"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          <div className="card asset-card">
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0">Asset List</h5>

                <div className="d-flex gap-2">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <Search />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search asset, outlet, serial no, QR, barcode..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>

                  <button className="btn btn-outline-secondary rounded-pill px-3">
                    <Download className="me-2" />
                    Export
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead>
                    <tr>
                      <th>Asset</th>
                      <th>Outlet</th>
                      <th>Category</th>
                      <th>Brand / Model</th>
                      <th>Ownership</th>
                      <th>Condition</th>
                      <th>Status</th>
                      <th>Next Service</th>
                      <th>AMC</th>
                      <th className="text-end">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredAssets.map((asset) => (
                      <tr key={asset._id}>
                        <td>
                          <div className="fw-bold">{asset.asset_name}</div>
                          <small className="text-muted">
                            {asset.asset_code} | SN: {asset.serial_no || "-"}
                          </small>
                          <br />
                          <small className="text-muted">
                            QR: {asset.qr_code || "-"} | BAR: {asset.barcode || "-"}
                          </small>
                        </td>

                        <td>
                          <div>{asset.outlet_name}</div>
                          <small className="text-muted">
                            {asset.outlet_code} | {asset.city}
                          </small>
                        </td>

                        <td>
                          <div>{asset.asset_category}</div>
                          <small className="text-muted">{asset.asset_type}</small>
                        </td>

                        <td>
                          <div>{asset.brand || "-"}</div>
                          <small className="text-muted">{asset.model_no || "-"}</small>
                        </td>

                        <td>
                          <div>{asset.ownership_type || "-"}</div>
                          <small className="text-muted">{asset.lifecycle_stage || "-"}</small>
                        </td>

                        <td>
                          <span className="badge bg-light text-dark border">{asset.condition}</span>
                        </td>

                        <td>
                          <span className={`badge ${badgeClass(asset.status)}`}>
                            {asset.status}
                          </span>
                        </td>

                        <td>{asset.next_maintenance_date || "-"}</td>

                        <td>
                          {asset.amc_available ? (
                            <span className="badge bg-success">YES</span>
                          ) : (
                            <span className="badge bg-secondary">NO</span>
                          )}
                        </td>

                        <td className="text-end">
                          <button className="btn btn-light action-btn me-1" onClick={() => setViewAsset(asset)}>
                            <ViewList />
                          </button>

                          <button className="btn btn-light action-btn me-1" onClick={() => handleEdit(asset)}>
                            <ArrowsExpandVertical />
                          </button>

                          <button className="btn btn-light text-danger action-btn" onClick={() => handleDelete(asset._id)}>
                            <ChevronDoubleLeft />
                          </button>
                        </td>
                      </tr>
                    ))}

                    {filteredAssets.length === 0 && (
                      <tr>
                        <td colSpan="10" className="text-center text-muted py-5">
                          No assets found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {viewAsset && (
            <div
              className="modal fade show"
              style={{
                display: "block",
                background: "rgba(15, 23, 42, 0.55)",
              }}
            >
              <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content border-0 rounded-4">
                  <div className="modal-header">
                    <h5 className="modal-title fw-bold">Asset Details</h5>
                    <button className="btn-close" onClick={() => setViewAsset(null)} />
                  </div>

                  <div className="modal-body">
                    <div className="row g-3">
                      {Object.entries(viewAsset).map(([key, value]) => {
                        if (key === "_id" || key === "maintenance_history" || key === "transfer_history") return null;

                        return (
                          <div className="col-md-4" key={key}>
                            <small className="text-muted text-uppercase">{key.replaceAll("_", " ")}</small>
                            <div className="fw-semibold">
                              {value === true ? "Yes" : value === false ? "No" : value || "-"}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <hr />

                    <h6 className="fw-bold">Maintenance History</h6>
                    {(viewAsset.maintenance_history || []).length === 0 ? (
                      <p className="text-muted">No maintenance history added.</p>
                    ) : (
                      <div className="table-responsive mb-3">
                        <table className="table table-sm table-bordered">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Type</th>
                              <th>Vendor</th>
                              <th>Technician</th>
                              <th>Cost</th>
                              <th>Issue</th>
                              <th>Work Done</th>
                              <th>Next Service</th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewAsset.maintenance_history.map((item, index) => (
                              <tr key={index}>
                                <td>{item.service_date || "-"}</td>
                                <td>{item.service_type || "-"}</td>
                                <td>{item.vendor_name || "-"}</td>
                                <td>{item.technician_name || "-"}</td>
                                <td>{item.cost || 0}</td>
                                <td>{item.issue_reported || "-"}</td>
                                <td>{item.work_done || "-"}</td>
                                <td>{item.next_service_date || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <h6 className="fw-bold">Transfer History</h6>
                    {(viewAsset.transfer_history || []).length === 0 ? (
                      <p className="text-muted">No transfer history added.</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                          <thead>
                            <tr>
                              <th>From Outlet</th>
                              <th>To Outlet</th>
                              <th>Date</th>
                              <th>Reason</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewAsset.transfer_history.map((item, index) => (
                              <tr key={index}>
                                <td>{item.from_outlet_name || "-"}</td>
                                <td>{item.to_outlet_name || "-"}</td>
                                <td>{item.transfer_date || "-"}</td>
                                <td>{item.reason || "-"}</td>
                                <td>{item.remarks || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  <div className="modal-footer">
                    <button className="btn btn-light rounded-pill px-4" onClick={() => setViewAsset(null)}>
                      Close
                    </button>

                    <button
                      className="btn btn-primary rounded-pill px-4"
                      onClick={() => {
                        handleEdit(viewAsset);
                        setViewAsset(null);
                      }}
                    >
                      Edit Asset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AssetAllocation;